import React, {
  useMemo,
} from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Menu, MenuItem, Typography } from '@mui/material';
import { getFrontEndByBackend } from '../../../const/meta';

function ContextMenu({
  left, top, onCloseMenu, detail, onDetailProcessing, allowedDetails, opened,
}) {
  const href = useMemo(
    () => detail && `${getFrontEndByBackend(detail.currentItem.backend)}${detail.currentItem.id}`,
    [detail],
  );
  return (
    <Menu
      open={opened}
      onClose={onCloseMenu}
      anchorReference="anchorPosition"
      anchorPosition={{ top, left }}
      PaperProps={{ sx: { maxHeight: 0.4 } }}
    >
      {detail && (
        <MenuItem onClick={onCloseMenu} component={Link} to={href} divider>
          {`Відкрити ${detail.currentItem.repr}`}
        </MenuItem>
      )}
      {onDetailProcessing && (
      <MenuItem disabled divider>
        <Typography variant="h6">
          Розшифрувати по:
        </Typography>
      </MenuItem>
      )}
      {onDetailProcessing && allowedDetails.map((c) => (
        <MenuItem
          key={c.key}
          onClick={(e) => onDetailProcessing(e, c, detail.currentItem)}
        >
          {c.label}
        </MenuItem>
      ))}
    </Menu>
  );
}

ContextMenu.propTypes = {
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  onCloseMenu: PropTypes.func.isRequired,
  detail: PropTypes.shape({
    currentItem: PropTypes.shape({
      backend: PropTypes.string,
      id: PropTypes.number,
      repr: PropTypes.string,
    }).isRequired,
  }),
  onDetailProcessing: PropTypes.func,
  allowedDetails: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  opened: PropTypes.bool,
};

ContextMenu.defaultProps = {
  opened: false,
  onDetailProcessing: null,
  detail: {},
};

export default ContextMenu;
